/**
 * ROMANTIC_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for the Romantic Genre (Chopin, Liszt, Tchaikovsky).
 * Features expressive dynamics, melody dominance, and prolonged harmonic tension.
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const ROMANTIC_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Voice Distribution: Ratio of activity (duration * velocity).
    // Romantic textures are often "Melody Dominant" (Soloist + Accompaniment).
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.35,  // Bass foundation
        mid: 0.40,  // Accompaniment (Arpeggios) - Heavily populated by Piano/Harp
        high: 0.25, // Melody/Soloist dominance - Single line vs Arpeggios
        tolerance: 0.15,
        tuttiThreshold: 0.90 // Higher threshold for Tutti (mostly limited to climaxes)
    },

    // Dynamic Curve: Standard Deviation of Velocity.
    // High variance due to Rubato, Espressivo, and dramatic swells.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.18, // Significant dynamic contrast required
        targetVariance: 0.25
    },

    // Interval Entropy: Probability of stepwise motion.
    // Romantic melodies are lyrical (stepwise) but allow for dramatic leaps (Appoggiatura).
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.40 // 40% stepwise (Reduced due to heavy arpeggiated accompaniment)
    }
};
